/**
* PORT-7
* Нет возможности прокрутки меню "on this page"
* Респонзив правого бара
* Блок: Правое меню
* Раздел: Документация
* На страницах с большим объёмом контента (например - UG Настройка фабрик/Настройка VXLAN) меню "on this page" не помещается на экране целиком, и не получается его прокрутить, чтобы увидеть оставшуюся часть.
**/
import "./right_sidebar.css"
import {route_parse} from "../function.js";

export function right_side_bar_size(){

    if (document.body.offsetWidth > 1260){
        $("#right-sidebar>div").css("width", $("#right-sidebar").width() + "px")
        const left=$("#right-sidebar").offset().left;
        $("#right-sidebar>div").css("left", left+20+"px")
    }

}

let active_hash

$(document).ready(function() {
    $(window).resize(function() {right_side_bar_size()});
    right_side_bar_size()
    $('#right-sidebar a.reference').click(function(e, d) {
        e.preventDefault();
        const hash=$(this).attr("href")
        if (hash=="#") {
            $('html, body').animate({
                scrollTop: 0
            }, 500); // 500 мс - время анимации
            return false;
        }
        const target=$("#block-main").find(`a[href="${hash}"]`)
        var scrollY = target.offset().top - 60;
        $('html, body').animate({
            scrollTop: scrollY
        }, 500); // 500 мс - время анимации
    });
    /**
     * скрытие шагов
     */

    $('#right-sidebar a.reference').each(function(k, e) {
        const text=$(this).text()
        if (isStep(text)) {
            $(this).closest("li").addClass("hidest")
        }
    })
    const route = route_parse()
    $('#right-sidebar a.reference').each(function(k, e) {
        /**
         * скрытие последнего уровня для cr
         */
        if (route[4]==="aqnos_cr_ru"||route[4]==="aqnos_cr_en") {
            let children =$(this).closest("ul").find("ul")
            if (children.length==0){
                $(this).closest("li").addClass("hidest")
            }

        }
    })

    function isStep(text){
        const regex_en = /^(step|Step).*?$/; // Пример регулярного выражения (только буквы и цифры)
        const regex_ru = /^(шаг|Шаг).*?$/; // Пример регулярного выражения (только буквы и цифры)
        if (regex_en.test(text)||regex_ru.test(text)) {
            return true
        }
        return false
    }
    $("#right-sidebar>div>div>div>ul>li>ul>li>ul").show()
    /**
     * массив якорей для прокрутки
     * @type {*[]}
     */
    const arr_hash=[]
    const arr_text=[]
    $('#right-sidebar a.reference').each(function(k, e) {
        const hash = $(this).attr('href');
        const text = $(this).text();
        if (!$(this).closest('li').hasClass('hidest')){
            arr_hash.push(hash)
            arr_text.push(text)
        }

    })

    $(window).scroll(function() {
        right_scroll()
    });
    right_scroll();

    function right_scroll(){
        // return false
        const scrollTop = $(window).scrollTop();
        right_side_bar_size()
        $('#right-sidebar a.reference').removeClass("active")
        let ind=false;

        arr_hash.map((hash, key)=>{
            if (hash=="#") return true;
            if (ind) return true
            const targetElement=$("#block-main").find(`a[href="${hash}"]`)
            let top=targetElement.offset().top-60
            let bottom=targetElement.offset().top + targetElement.height()
            if (top <= $(window).scrollTop() + $(window).height() && bottom >= $(window).scrollTop()) {
                if (isStep(arr_text[key])) {
                    return true
                }
                active_hash=$(`a[href="${hash}"]`)
                active_hash.addClass('active');
                ind=true
            } else {
                if (active_hash!==undefined)
                    active_hash.addClass('active');
            }
        })

        // фиксация меню
        if (document.body.offsetWidth < 1260) return false;
        if (scrollTop >= $(".header__top").outerHeight()+50) {
            $("#right-sidebar>div").addClass("right_bar_fix");
            var blockHeight = $(document).height() - scrollTop-$('.footer').outerHeight()-80;
            $("#right-sidebar>div").css("max-height", blockHeight + "px")
        } else {
            $("#right-sidebar>div").removeClass("right_bar_fix");
            $("#right-sidebar>div").css("max-height", "none")
        }
    }


    $("#right-sidebar>div>div").prepend(
    `
           <div class="menu__header secondary d-flex align-center justify-space-between"> 
           <div class="menu__prev link link--white">
           <i aria-hidden="true" class="v-icon notranslate ci ci-chevron_big_left theme--light" style="font-size:24px"></i>
           </div> 
           <div class="menu__title text-body-1 white--text fw-500">Меню</div> 
               <div id="mm_close_right_sidebar" class="link link--white"> 
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                        <path d="M21 21L3 3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M21.0001 3L3 21.0001" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> 
                    </svg> 
               </div> 
           </div>
    `);
    if (window.config.auth.id_category==1)
    {
        $("#right-sidebar>div").addClass("admin")
    }
    $('#toggle_right_sidebar').click(function(e, d) {
        if ($("#right-sidebar>div>div>div").text().trim()=="Меню") return false;
        $("#right-sidebar>div").addClass("open")
    })
    $('#mm_close_right_sidebar').click(function(e, d) {
        $("#right-sidebar>div").removeClass("open")
    })

    if ($("#right-sidebar>div>div>div").text().trim()=="Меню"){
        $(".btn_toggle_right_sidebar").addClass("disable")
    }

});


